import radar from '../imgs/radar.webp';
import ball1 from '../imgs/dragonball1.webp';
import ball2 from '../imgs/dragonball2.webp';
import ball3 from '../imgs/dragonball3.webp';
import '../styles/RadarLoader.css';

const SEEN_KEY = 'isn:radar-seen';

/**
 * Whether the branded loader should be used for this visit. It runs once per
 * session so it stays a moment rather than a tax on every page view; every
 * other load falls back to plain skeletons.
 *
 * Wrapped in try/catch because sessionStorage throws in private-mode and
 * embedded contexts.
 */
export const shouldShowRadar = () => {
  try {
    if (sessionStorage.getItem(SEEN_KEY)) return false;
    sessionStorage.setItem(SEEN_KEY, '1');
    return true;
  } catch {
    return false;
  }
};

const balls = [ball1, ball2, ball3];

const RadarLoader = () => (
  <div className="radar-loader" role="status" aria-label="Loading announcements">
    <div className="radar-loader__dish">
      <span className="radar-loader__ring" />
      <img src={radar} alt="" />
    </div>
    <div className="radar-loader__balls">
      {balls.map((src, i) => (
        <img key={src} src={src} alt="" style={{ '--i': i }} />
      ))}
    </div>
    <p className="radar-loader__caption">Scanning for announcements</p>
  </div>
);

export default RadarLoader;
